export const DEADLINE_STATUS = {
    satisfied: "Satisfied",
    pending: "Pending",
    expired: "Expired"
};

export const DEADLINE_ACTIVITY_STATUS_ID = {
    running: 1,
    paused: 2,
    finished: 3
};
